import { ChevronDown } from 'lucide-react'
import { useState } from 'react'

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { cn } from '@/lib/utils'
import type { RelayFaqItem } from '../content/amazonRelayContent'

export interface RelayFaqProps {
  faqs: RelayFaqItem[]
}

/** Single-open accordion on a dark ground; the first question starts open. */
export function RelayFaq({ faqs }: RelayFaqProps) {
  const [openIndex, setOpenIndex] = useState(0)

  return (
    <div className="flex min-w-0 flex-col border-t border-white/16">
      {faqs.map((faq, i) => {
        const open = openIndex === i
        return (
          <Collapsible
            key={faq.question}
            open={open}
            onOpenChange={(next) => setOpenIndex(next ? i : -1)}
            className="border-b border-white/16"
          >
            <CollapsibleTrigger className="group hover:text-brand-400 flex w-full cursor-pointer items-center justify-between gap-6 py-5 text-left text-lg leading-[1.45] font-semibold text-white transition-colors">
              <span className="min-w-0 flex-1">{faq.question}</span>
              <ChevronDown
                className={cn(
                  'size-6 shrink-0 transition duration-150 lg:opacity-0 lg:group-hover:opacity-100 lg:group-focus-visible:opacity-100',
                  open && 'rotate-180'
                )}
              />
            </CollapsibleTrigger>
            <CollapsibleContent>
              <p className="text-md text-ink-200 pt-1 pr-12 pb-7 leading-[1.65] text-pretty">{faq.answer}</p>
            </CollapsibleContent>
          </Collapsible>
        )
      })}
    </div>
  )
}
